export default __webpack_public_path__ + "static/02-365d636d355c350f1e30a816b8828101.jpg";